import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    number: '01',
    title: 'BONO 1 — Kit de Arranque Rápido',
    description: 'Empezá a vender en 7 días, no en 7 meses. Tu hoja de ruta para la primera semana: qué comprar primero, qué receta hacer primero, cómo sacar la primera foto y cómo conseguir el primer cliente. Sin vueltas.',
    value: '$14.990',
    image: ''
  }, {
    number: '02',
    title: 'BONO 2 — Calendario Express de Contenido',
    description: 'Nunca más te quedés sin saber qué postear. 30 días de ideas de contenido para Instagram y WhatsApp, adaptadas al mundo de las minidonas. Posts, historias, promociones y fechas especiales ya planificadas.',
    value: '$17.990',
    image: ''
  }, {
    number: '03',
    title: 'BONO 3 — Banco de Nombres y Frases para Vender',
    description: 'Las palabras exactas que hacen que la gente compre. +50 nombres creativos para tu emprendimiento, frases para tus historias de Instagram, textos para tu catálogo de WhatsApp y respuestas para las preguntas más comunes de tus clientes.',
    value: '$12.990',
    image: ''
  }, {
    number: '04',
    title: 'BONO 4 — Tortas y Torres Temáticas con Minidonas',
    description: 'El producto estrella que cobra el triple. Aprendé a armar tortas y torres de minidonas dignas de pastelería premium para cumpleaños, casamientos y eventos. La guía visual con paso a paso, estructuras, decoración y precios sugeridos para que vendas piezas únicas que tus clientas no encuentran en ningún otro lado.',
    value: '$19.990',
    image: 'https://cdn.magicpatterns.com/uploads/dBXBefyh2YX9EAWa6jpJbE/bono_4_-_minidonas.png',
    highlight: true,
    badge: 'EL MÁS PEDIDO'
  }];
  return <section className="w-full bg-[#FFFFFF] py-16 md:py-24 relative" data-id="element-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative" data-id="element-17">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-18">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3E2B1F] text-center mb-12" data-id="element-19">
            4 BONOS ESTRATÉGICOS — SIEMPRE INCLUIDOS
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8 mb-12" data-id="element-20">
            {bonuses.map((bonus, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1,
            duration: 0.6
          }} className={`rounded-2xl p-6 md:p-8 relative overflow-hidden transition-all duration-300 ${bonus.highlight ? 'bg-[#F7F2EA] border-2 border-[#B66A2C] shadow-premium hover:shadow-premium-hover' : 'bg-[#F7F2EA] border border-[#E7DDD2] shadow-sm hover:shadow-premium'}`} data-id="element-21">
                {bonus.image && <div className="absolute top-4 right-4 w-16 h-20" style={{
              perspective: '500px'
            }} data-id="element-22">
                    <div className="relative w-full h-full rounded shadow-md" style={{
                transform: 'rotateY(-15deg)',
                transformStyle: 'preserve-3d'
              }} data-id="element-23">
                      <img src={bonus.image} alt="" className="w-full h-full object-cover rounded" data-id="element-24" />
                      <div className="absolute top-0 left-0 w-[4px] h-full bg-gradient-to-r from-[#E7DDD2] to-[#F7F2EA] rounded-l" data-id="element-25" />
                      <div className="absolute inset-0 rounded bg-gradient-to-r from-black/5 via-transparent to-transparent pointer-events-none" data-id="element-26" />
                    </div>
                  </div>}
                {bonus.highlight && bonus.badge && <div className="inline-block bg-[#B66A2C] text-white text-xs font-bold tracking-widest px-3 py-1.5 rounded-full mb-4 uppercase" data-id="element-27">
                    {bonus.badge}
                  </div>}
                <div className="flex items-center gap-3 mb-4" data-id="element-28">
                  <div className="bg-white p-2 rounded-full shadow-sm" data-id="element-29">
                    <GiftIcon className="w-5 h-5 text-[#B66A2C]" data-id="element-30" />
                  </div>
                  <span className="text-sm font-bold text-[#B66A2C] tracking-widest" data-id="element-31">
                    #{bonus.number}
                  </span>
                </div>
                <h3 className={`font-serif text-xl md:text-2xl font-bold text-[#3E2B1F] mb-4 ${bonus.image ? 'pr-16' : ''}`} data-id="element-32">
                  {bonus.title}
                </h3>
                <p className="text-[#3E2B1F]/80 text-base mb-6 leading-relaxed" data-id="element-33">
                  {bonus.description}
                </p>
                <div className="flex items-center gap-3 mt-auto pt-4 border-t border-[#E7DDD2]" data-id="element-34">
                  <span className="text-[#3E2B1F]/50 line-through text-base" data-id="element-35">
                    {bonus.value}
                  </span>
                  <span className="text-[#C96B17] font-bold text-lg" data-id="element-36">
                    GRATIS
                  </span>
                </div>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="text-center bg-[#F3ECE2] border border-[#E7DDD2] rounded-2xl p-6 max-w-2xl mx-auto shadow-sm" data-id="element-37">
            <p className="text-lg md:text-xl font-medium text-[#3E2B1F]" data-id="element-38">
              Valor total de los bonos:{' '}
              <span className="line-through text-[#3E2B1F]/50" data-id="element-39">$65.960</span>
              {' → '}
              <span className="text-[#C96B17] font-bold" data-id="element-40">
                GRATIS con tu Mega Pack
              </span>
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}